<template>
  <div id="about-business" class="business" data-aos="fade-down" data-aos-duration="1500">
    <div class="business-row container">
      <MyTitle>
        <template v-slot:title><b style="color: #1E55AE">核心</b>业务</template>
        <template v-slot:subtitle><p style="margin-top: 10px;">
          为客户提供投资咨询、开发设计、设备成套、施工安装、监理监造、运营管理、优化管理等一体化的跨专业的综合技术服务，融合各专业的优势和根据客户的需求制定可靠、经济性好的个性化技术方案，保证电站建设能最大限度地节约成本、加快进度、提高效率和保证安全，使水电站的项目管理得到事半功倍的成效。</p>
        </template>
      </MyTitle>
      <ul>
        <li v-for="item in businessList" :key="item.id" data-aos="fade-up" :data-aos-duration="1500">
          <div>
            <el-image :src="item.image_url"></el-image>
          </div>
          <p>{{ item.title }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Business",
  data() {
    return {
      businessList: [
        {id: 1, title: '工程勘探设计', image_url: require('@/assets/images/business1.png')},
        {id: 2, title: '工程施工总承包', image_url: require('@/assets/images/business6.png')},
        {id: 3, title: '工程技术咨询', image_url: require('@/assets/images/business2.png')},
        {id: 4, title: '机电设备成套', image_url: require('@/assets/images/business3.png')},
        {id: 5, title: '水电产品研发', image_url: require('@/assets/images/business4.png')},
        {id: 6, title: '技术培训', image_url: require('@/assets/images/business5.png')},
      ]
    }
  }
}
</script>

<style scoped lang="less">
.business {
  padding: 110px 0;

  .business-row {

    ul {
      display: flex;
      justify-content: space-between;
      margin-top: 80px;
      font-size: 16px;

      li {
        text-align: center;

        & > div {
          display: flex;
          justify-content: center;
          margin-bottom: 25px;
        }
      }
    }
  }
}
</style>